import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home } from 'lucide-react';
import { visibleCategories, entriesInCategory, categoryCount, entryPath } from '../../utils/guideIndex';
import { ExplorerNavLinks } from './ExplorerNavLinks';
import { VerificationAccessLink } from './VerificationAccessLink';
export function GuideSidebar() {
  const {
    pathname
  } = useLocation();
  const activeCategory = pathname.split('/')[2];
  return <nav aria-label="Categorías de la guía" className="sticky top-28 max-h-[calc(100vh-8rem)] overflow-y-auto pr-2 pb-8" data-id="element-482" data-mp="1o3wn12c569xy">
      <NavLink to="/guia" end className={({
      isActive
    }) => `flex items-center gap-2.5 rounded-xl px-3 py-2 text-sm font-semibold transition-colors duration-150 ${isActive ? 'bg-white/[0.06] text-[#D4AF37]' : 'text-gray-300 hover:text-white'}`} data-id="element-483" data-mp="1y09gq07osnsp">
        <Home className="h-4 w-4" aria-hidden="true" data-id="element-484" data-mp="39hrfelaeux8d" />
        Inicio de la guía
      </NavLink>
      <p className="mt-6 mb-2 px-3 text-xs font-semibold text-gray-500" data-id="element-485" data-mp="3egcfmkpnxgwt">Explorador</p>
      <ExplorerNavLinks data-id="element-486" data-mp="qtzebyexwfd3" />
      <p className="mt-6 mb-2 px-3 text-xs font-semibold text-gray-500" data-id="element-487" data-mp="lwz5xgumb0it">Categorías</p>
      <ul className="space-y-0.5" data-id="element-488" data-mp="lv62eafawwf1">
        {visibleCategories.map(c => {
        const Icon = c.icon;
        const isActive = activeCategory === c.id;
        const entries = entriesInCategory(c.id);
        return <li key={c.id} data-id="element-489" data-mp="7xr8ase3s0gq">
              <NavLink to={`/guia/${c.id}`} end className={`flex items-start gap-2.5 rounded-xl px-3 py-2 text-sm transition-colors duration-150 ${isActive ? 'bg-white/[0.06] text-white' : 'text-gray-400 hover:text-white'}`} data-id="element-490" data-mp="7xzjmfukuxpt">
                <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${isActive ? 'text-[#D4AF37]' : ''}`} aria-hidden="true" data-id="element-491" data-mp="3qc8jucllwg6c" />
                <span className="flex-1 leading-snug" data-id="element-492" data-mp="3lbktzu9465dp">{c.title}</span>
                <span className="text-xs tabular-nums text-gray-500" data-id="element-493" data-mp="3gcrczrumbw8s">{c.comingSoon && !categoryCount(c.id) ? 'Pronto' : categoryCount(c.id)}</span>
              </NavLink>
              {isActive && entries.length > 0 && <ul className="mb-2 ml-5 mt-1 space-y-0.5 border-l border-white/10" data-id="element-494" data-mp="3bq31vqd3epdg">
                  {entries.map(e => <li key={e.id} data-id="element-495" data-mp="2wtlrp2gn3gsh">
                      <NavLink to={entryPath(e)} className={({
                isActive: on
              }) => `-ml-px block border-l-2 py-1.5 pl-3.5 text-[13px] transition-colors duration-150 ${on ? 'border-[#D4AF37] text-[#D4AF37]' : 'border-transparent text-gray-400 hover:text-white'}`} data-id="element-496" data-mp="31psqmbambs0x">
                        {e.title}
                      </NavLink>
                    </li>)}
                </ul>}
            </li>;
      })}
      </ul>
      <div className="mt-8" data-id="element-497" data-mp="h03azw23c276">
        <VerificationAccessLink data-id="element-498" data-mp="h0cz1e3krza8" />
      </div>
    </nav>;
}